import { RouteSection } from "./api/types";

// Official TFL line colours.
const TUBE_LINE_COLOURS: { [lineId: string]: string } = {
  bakerloo: "#B36305",
  central: "#E32017",
  circle: "#FFD300",
  district: "#00782A",
  "hammersmith-city": "#F3A9BB",
  jubilee: "#A0A5A9",
  metropolitan: "#9B0056",
  northern: "#000000",
  piccadilly: "#003688",
  victoria: "#0098D4",
  "waterloo-city": "#95CDBA",
};

const MODE_COLOURS: { [mode: string]: string } = {
  "elizabeth-line": "#6950A1",
  dlr: "#00A4A7",
  overground: "#EE7C0E",
  tram: "#84B817",
  bus: "#EE1C25",
  "national-rail": "#000000",
  "river-bus": "#0072BC",
  "cable-car": "#E21836",
};

const WALKING_COLOUR = "#777777";
const UNKNOWN_COLOUR = "#555555";

export interface SectionStyle {
  color: string;
  dashArray?: string;
}

export const styleForSection = (section: RouteSection): SectionStyle => {
  if (section.mode === "walking") {
    return {
      color: WALKING_COLOUR,
      // Dotted for the estimated final leg, dashed for ordinary walking.
      dashArray: section.estimated ? "1 8" : "8 8",
    };
  }

  if (section.lineId && TUBE_LINE_COLOURS[section.lineId]) {
    return { color: TUBE_LINE_COLOURS[section.lineId] };
  }

  return { color: MODE_COLOURS[section.mode] ?? UNKNOWN_COLOUR };
};

// Human-readable label for a route section, e.g. "Victoria Line" or "National rail".
export const labelForSection = (section: RouteSection): string => {
  if (section.mode === "walking") {
    return section.estimated ? "Walk (estimated)" : "Walk";
  }
  if (section.lineName) {
    return section.lineName;
  }
  const pretty = section.mode.replace(/-/g, " ");
  return pretty.charAt(0).toUpperCase() + pretty.slice(1);
};
